<template>
    <div class="sub-head">
        <div class="sub-visual">
            <v-container>
                <tit data-aos="fade-up" data-aos-delay="100" class="tit--xl white--text">{{ sh }}</tit>
            </v-container>
            <div class="sub-visual__bg" :style="'background-image:url(' + bg + ');'"></div>
        </div>
        <client-gnb v-if="tabActive" className="sub-tab" :tabActive="tabActive" :sh="sh"></client-gnb>
    </div>
</template>

<script>
import ClientGnb from "@/components/client/inc/client-gnb.vue";
import Tit from "@/components/publish/styles/typography/tit.vue";

export default {
    props: {
        sh: { type: String, default: "" },
        bg: { type: String, default: "" },
        tabActive: { type: String, default: "" },
    },
    components: {
        ClientGnb,
        Tit,
    },
    data: () => {
        return {};
    },
};
</script>

<style lang="scss" scoped>
/* sub-visual */
.sub-visual {
    position:relative;
    display: flex;
    align-items: center;
    height: 200px;
    padding-top: var(--header-body-height);
}
.sub-visual__bg {
    position: absolute;
    top:0;
    left: 50%;
    z-index: -1;
    -webkit-transform: translate(-50%,0); -ms-transform: translate(-50%,0); transform: translate(-50%,0);
    width: 100vw;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
}
.sub-tab{
    ::v-deep{
        .container{
            max-width: var(--container);
            padding: 0;
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .sub-visual {
        height: 300px;
    }
}
@media (min-width: 1024px) {
    .sub-visual {
        height: 540px;
    }
}
@media (min-width: 1200px) {
}
</style>
